import { render, staticRenderFns } from "./ParentsPhoneDialog.vue?vue&type=template&id=b9d242ae"
import script from "./ParentsPhoneDialog.vue?vue&type=script&lang=js"
export * from "./ParentsPhoneDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports